import React from 'react';
export const successSvg = () => {
    return (
        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 2C17.8378 3.05952 7 14 6 14C5 14 0.5 8.5 0.5 8.5C0.604531 7.44917 0.909405 7.13854 1.91 7.09L6 11.17L16.59 0.589996C17.8554 0.628501 18.1622 0.940468 18 2Z" fill="#4ECB71"/>
        </svg>
    )
}

